import { TranslationContext } from "@clockwise/client-commons/src/providers/TranslationContext";
import { Link } from "@clockwise/design-system";
import React, { useContext } from "react";
import { AutopilotStatusCard } from "../AutopilotStatusCard";

type Props = {
  openPricingDialog: (open: boolean) => void;
  numEvents: number;
};

export const AutopilotStatusTrialExpired = ({ openPricingDialog, numEvents }: Props) => {
  const t = useContext(TranslationContext);
  const onClickUpgrade = () => {
    openPricingDialog(true);
  };

  return (
    <AutopilotStatusCard
      title={
        numEvents > 0
          ? t("autopilot-status:paused", { count: numEvents })
          : t("autopilot-status:empty")
      }
      description={
        <div className="cw-flex cw-items-center cw-text-xs cw-text-neutral-muted">
          <span>
            <Link target="_blank" rel="noreferrer" onClick={onClickUpgrade}>
              Upgrade
            </Link>{" "}
            to enable flexible meetings
          </span>
        </div>
      }
      tooltipText="Your Teams trial has expired. Please upgrade to let Clockwise automatically move your meetings"
      warning
    />
  );
};
